import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { PagoService } from '../../../services/pago.service';
import { UserService } from '../../../services/user.service';
import { Methods } from "../../../shared/methods";
import { Cell, DinamicData } from "src/app/models/dinamic-data";
import { ConfigService } from '../../../services/config.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { finalize, take } from 'rxjs';
import Swal from 'sweetalert2';
import { RejectpaymentComponent } from '../rejectpayment/rejectpayment.component';
import { ModalpayComponent } from '../modalpay/modalpay.component'; 
import { GuiGuard } from "../../../shared/guard/base-gui-guard";

interface Check {
  payableTo: string | null;
  amount: number | null;
}
@Component({
  selector: 'app-viewpayment',
  templateUrl: './viewpayment.component.html',
  styleUrls: ['./viewpayment.component.css'],
  providers: [UserService, PagoService, GuiGuard]
})
export class ViewpaymentComponent implements OnInit {
  public paymentdata;
  token: string;
  public loading = true;
  checks: Check[] = [];
  public notesFatherId!: string;
  public notesType = 'PAYMENT';
  public fatherid;
  public PaymentID;
  history: any[] = [];
  public Clientname = "";
  constructor( public guard: GuiGuard,
    private fb: FormBuilder,
    private _pagoService: PagoService,
    private _userService: UserService,   private dialog: MatDialog,   private dialogRef: MatDialogRef<ViewpaymentComponent>,  @Inject(MAT_DIALOG_DATA) public data: { id: number }
  ) {
    this.token = this._userService.getToken();
    
  }


  ngOnInit() {
    this.getPayment(this.data.id);
    this.fatherid = this.data.id;
    this.notesFatherId = `payment-${this.data.id}`;
  }

  private getPayment(id: number): void {
    this.loading = true;
    this._pagoService
      .getpaymentbyid(this.token, { id })
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        next: ({ status, data }) => {
          if (status === 'success') {
            this.paymentdata = data;
            this.PaymentID = data.id;
            this.buildChecks(data.methodDetail);
            this.history = data.history || [];
            if(data.paymentType === "PO"){
              this.Clientname = data.items[0].processingInstruction.clientName;
            }else if(data.paymentType === "CONSIGNMENT"){
              this.Clientname = data.CosigmentDetail.clientname;
            }
          }
        },
        error: (err) => console.error('Error al obtener pago', err)
      });
  }
  formatAction(action: string): string {
    return action.charAt(0).toUpperCase() + action.slice(1).toLowerCase();
  }
  private confirmApprove() {
    Swal.fire({
      title: 'Are you sure?',
      text:  'Do you really want to approve this payment?',
      icon:  'question',
      showCancelButton: true,
      buttonsStyling: false,

      customClass:{
    confirmButton: 'gts-btn-primary',
    cancelButton: 'gts-btn-primary-outline',
            },
      confirmButtonColor: '#9c27b0',
      confirmButtonText: 'Yes, approve it',
      cancelButtonText: 'Cancel'
    }).then(r => {
      if (r.isConfirmed) this.changeStatus('Approve');
    });
  }
  
  private confirmPaid() {
    const dialogRef = this.dialog.open(ModalpayComponent, {
      width: '500px',
      data: {
        id:  this.PaymentID ,           
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getPayment(this.PaymentID)
      }
    });
/*     Swal.fire({
      title: 'Mark as paid?',
      text:  'This will set status to Paid.',
      icon:  'question',
      buttonsStyling: false,

      customClass:{
    confirmButton: 'gts-btn-primary',
    cancelButton: 'gts-btn-primary-outline',
            },
      confirmButtonColor: '#9c27b0',
      showCancelButton: true,
      confirmButtonText: 'Yes, mark paid',
      cancelButtonText: 'Cancel'
    }).then(r => {
      if (r.isConfirmed) this.changeStatus('Paid');
    }); */
  }
  
  private confirmReject() {
    Swal.fire({
      title: 'Are you sure?',
      text:  'Do you really want to reject this payment?',
      icon:  'warning',
      showCancelButton: true,
      buttonsStyling: false,

      customClass:{
    confirmButton: 'gts-btn-primary',
    cancelButton: 'gts-btn-primary-outline',
            },
      confirmButtonColor: '#9c27b0',
      confirmButtonText: 'Yes, reject it',
      cancelButtonText: 'Cancel'
    }).then(r => {
      if (r.isConfirmed) this.openRejectDialog();
    });
  }
  
  private openRejectDialog() {
    const ref = this.dialogRef; 
    const d = (this as any).dialog.open(RejectpaymentComponent, {
      width: '400px',
      data: { paymentId: this.paymentdata.id }
    });
    d.afterClosed().subscribe((note: string | undefined)  => {
      if (typeof note === 'string' && note.trim().length > 0) {
        this.changeStatus('Reject', note);
      }
    });
  }
  
  /**  
   *  
   */
  private changeStatus(action: 'Approve'|'Reject'|'Paid', note?: string) {
    const s = this.paymentdata.status.toLowerCase();
    let newStatus: string;
    let actionType: string;
  
    switch (action) {
      case 'Approve':
        actionType = 'APPROVED';
        if (s === 'pending approval') {
          newStatus = 'Partially Approved';
        } else if (s === 'partially approved') {
          newStatus = 'Approved';
        } else if (s === 'rejected') {
          
          newStatus = 'Pending Approval';
        } else {
         
          newStatus = 'Approved';
        }
        break;
  
      case 'Reject':
        actionType = 'REJECTED';
        newStatus   = 'Rejected';
        break;
  
      case 'Paid':
        actionType = 'PAID';
        newStatus   = 'Paid';
        break;
    }
  
    const payload: any = {
      id:     this.paymentdata.id,
      status: newStatus,
      action: newStatus
    };
    if (note) payload.note = note;
  
    this._pagoService.changestatus(this.token, payload)
      .pipe(finalize(() => {
        
        this.getPayment(this.paymentdata.id)
        this.showToast('success', `Status changed to ${newStatus}`, 2000);
      }))
      .subscribe();
  }
  
  close() {
    this.dialogRef.close();
  }
Aprove(){

}
Reject(){

}
/*   get checks() {
    const md = this.paymentdata?.methodDetail;
    if (!md) return [];
    const arr = [];
    for (let i = 1; i <= (md.numberOfChecks || 0); i++) {
      const payable = md[`checkPayableTo${i}`];
      const amount  = md[`checkAmount${i}`];
      if (payable != null || amount != null) {
        arr.push({ payableTo: payable, amount });
      }
    }
    return arr;
  } */
  
  statusKey(status: string): string {
    return (status || '')
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z\-]/g, '');
  }
  get poList(): string {
    return (this.paymentdata?.items || [])
      .map(item => item.poInfo.po)
      .join(', ');
  }
  trackByIdx = (_: number, item: Check) => item;

  private buildChecks(md: any): void {
    this.checks = [];
    if (!md) {
      return;
    }

    const num = md.numberOfChecks ?? 0;
    for (let i = 1; i <= num; i++) {
      const payable = md[`checkPayableTo${i}`] ?? null;
      const amount = md[`checkAmount${i}`] ?? null;
      if (payable != null || amount != null) {
        this.checks.push({ payableTo: payable, amount });
      }
    }
  }
  formatMethodType(methodType?: string): string {
    if (!methodType) return '';
    const siglas = ['ACH', 'WT', 'ATM'];
    return methodType
      .split('_')
      .map((word, idx) => {
        if (idx === 0 && siglas.includes(word.toUpperCase())) {
          return word.toUpperCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }
  

  showToast(type, title, timer) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }
  get showReject(): boolean {
    const s = this.paymentdata?.status;
    return s === 'Pending Approval'
        || s === 'Partially Approved'
        || s === 'Approved';
  }
  
  get showApprove(): boolean {
    const s = this.paymentdata?.status;
    return s === 'Pending Approval'
        || s === 'Partially Approved';
      /*   || s === 'Rejected'; */
  }
  
  get showPaid(): boolean {
    return this.paymentdata?.status === 'Approved';
  }
  addSpacesToLabel(str: string): string {
    if (!str) return '';
    return str.replace(/([a-z])([A-Z])/g, '$1 $2')
              .replace(/_/g, ' ')
              .replace(/^./, (s) => s.toUpperCase());
  }
}
